var getHostname = function () {
    var url = new URL(window.location.href);
    return url.hostname;
};
export default getHostname;
